import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const { NAME } = require('../store/models/questionnaires');

const useQuestionnaires = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.loading.models[NAME]);
  const { questionnaires } = useSelector(state => state[NAME]);

  const load = useCallback(() => {
    dispatch[NAME].load();
  }, [dispatch]);

  const createSession = useCallback(payload => dispatch[NAME].createSession(payload), [dispatch]);

  return { isLoading, questionnaires, load, createSession };
};

export default useQuestionnaires;
